import React, { useEffect } from 'react';

import { usePostState, usePostActions } from './PostContext';

import { updatePostViewState } from '../../Feed/components/restApi';
import { ReadOnlyDocumentContent } from '../../RichTextEditor';

import styles from './Post.module.scss';

const Post = ({
  post,
  handleOpenCommentModal,
  handleOpenCommentFormModal,
  setFeedbackMessage,
  setFeedbackVariant,
  moveViewState,
}) => {
  const state = usePostState();
  const {
    initializeState,
    setExpanded,
    setSubTextContainerIsLongerThanTextContainer,
    onError,
  } = usePostActions(post.id);

  const postState = state?.posts?.[post.id];

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    if (postState) {
      const isLonger = document.getElementById(`subSubTextContainer_${post.id}`)?.offsetHeight > document.getElementById(`subTextContainer_${post.id}`)?.offsetHeight;
      if (isLonger !== postState.subTextContainerIsLongerThanTextContainer) {
        setSubTextContainerIsLongerThanTextContainer(isLonger);
      }
    }
  }, [post.id, postState?.expanded]);

  const goToAuthorProfile = () => {
    window.location.assign(post.author.path);
  }

  const mustBeExpandedToViewAllPostText = () => {
    return !postState?.expanded && postState?.subTextContainerIsLongerThanTextContainer;
  }

  const updatePostViewStateWrapper = (postId, state_event) => {
    updatePostViewState({
      postId,
      onResponse: (data) => {
        if (data.feedbackVariant === 'success') {
          moveViewState(data.post, data.post.viewState);
          setFeedbackMessage(data.feedbackMessage || null);
          setFeedbackVariant('success');
        } else {
          onError({ feedbackMessage: data.feedbackMessage || null });
        }
      },
      onError,
      body: {
        state_event,
        authenticity_token: document.querySelector("meta[name='csrf-token']").getAttribute("content")
      },
    })
  };

  const finalLink = post.link?.includes('http') ? post.link : `//${post.link}`;

  const subTextContainerStyle = postState?.expanded ? styles.subTextContainer : styles.abbreviatedSubTextContainer;

  const showCommentOption = post.viewState == 'approved';

  const showSubmitOption = (post.viewState == 'draft') && post.author.canAdministratePosts;

  const showReviewOptions = (post.viewState == 'pending_approval') && post.author.canAdministratePosts;

  return (
    <div className={styles.post}>
      {!!post.link ? (
        <a href={finalLink} target="_blank" rel="noopener noreferrer"><img className={styles.img} src={post.imagePath} /></a>
      ) : (
        <img className={styles.img} src={post.imagePath} />
      )}
      <div className={styles.authorIntro}>
        <img className={styles.authorPicture} src={post.author.profilePicturePath} onClick={goToAuthorProfile}></img>
        <p className={styles.authorName}  onClick={goToAuthorProfile}>{post.author.name}</p>
        <p className={styles.authorTagline}  onClick={goToAuthorProfile}>{post.author.primaryUserTag}</p>
        <p className={styles.postDate}>{`Posted On ${new Date(Date.parse(post.createdAt)).toLocaleDateString()}`}</p>
      </div>
      <div className={styles.textContainer}>
        <div id={`subTextContainer_${post.id}`} className={subTextContainerStyle}>
          <div id={`subSubTextContainer_${post.id}`} className={styles.subSubTextContainer}>
            <ReadOnlyDocumentContent documentComponents={post.latestVersion?.documentComponents} />
          </div>
        </div>
        {mustBeExpandedToViewAllPostText() && (
          <p className={styles.showMore} onClick={() => setExpanded(true)}>...Show More</p>
        )}
      </div>
      <hr className={styles.spacer}/>
      <div className={styles.commentsCountContainer}>
        <p className={styles.commentsCount} onClick={post.comments.length ? () => handleOpenCommentModal({commentParentId: post.id, commentParentType: 'Post'}) : () => {}}>{`${post.comments.length} ${post.comments.length == 1 ? 'Comment' : 'Comments'}`}</p>
      </div>
      <hr className={styles.spacer}/>
      <div className={styles.interactionsContainer}>
        {showCommentOption && <p className={styles.interaction} onClick={() => handleOpenCommentFormModal({commentParentId: post.id, commentParentType: 'Post'})}>Make Comment</p>}
        {showSubmitOption && <p className={styles.interaction} onClick={() => updatePostViewStateWrapper(post.id, 'request_approval')}>Submit For Review</p>}
        {showReviewOptions && <p className={styles.interaction} onClick={() => updatePostViewStateWrapper(post.id, 'approve')}>Approve</p>}
        {showReviewOptions && <p className={styles.interaction} onClick={() => updatePostViewStateWrapper(post.id, 'deny')}>Deny</p>}
      </div>
    </div>
  );
};

export default Post;
